<template>
  <div class="topic" :class="{clickable: action != null}" @click="execute">
    <div class="icon">
      <img :src='publicIcon+icon'/>
    </div>
    {{text}}
  </div>
  
</template>

<script>


export default {
  name: 'Topic',
  props:{
    icon: String,
    text: String,
    action: Function
  },
  data() {
    return {
      publicIcon: process.env.BASE_URL+'svg/'
    }
  },
  methods: {
    execute(){
      if(this.action != null){
        this.action();
      }
    }
  }

}
</script>

<style scoped>

.topic{
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}

.clickable{
  text-decoration: underline;
  cursor:pointer;
}


.icon{
  min-height: 3em;
  max-height: 3em;
  min-width: 3em;
  position: relative;
  display: block;
  align-content: center;
}

.icon *{
  height: 100%;
}


</style>

